(function () {

  'use strict';
  
    function filterDropdownService(localStorageService, $cookies) {

    let storageObject = null;
    if (localStorageService.isSupported) {
      storageObject = localStorageService;
    } else {
      storageObject = $cookies;
      storageObject.set = function (key, value) {
        return storageObject.put(key, value);
      };
    }

    function createFilterModel(filters) {
      const filterModel = {};
      for (let i = 0; i < filters.length; i++) {
        const rangeObject = {
          range: []
        };
        for (let j = 0; j < filters[i].values.length; j++) {
          if (filters[i].type === 'range' || filters[i].type === 'range-input' || filters[i].type === 'range-date') {
            rangeObject.type = filters[i].type;
            rangeObject.pristine = true;
            rangeObject.range.push(filters[i].values[j].initialCount);
            filterModel[filters[i].values[j].sharedKey] = rangeObject;
          } else {
            filterModel[filters[i].values[j].key] = {
              state: null,
              type: filters[i].type,
              name: filters[i].name,
              value: filters[i].values[j].value,
              key: filters[i].values[j].key,
              parameter: filters[i].parameter
            };
          }
        }
      }
      return filterModel;
    }

    function updateFilterModel(filters, filterModel) {
      for (let i = 0; i < filters.length; i++) {
        if (filters[i].type !== 'range' && filters[i].type !== 'range-input' && filters[i].type !== 'range-date') {
          for (let j = 0; j < filters[i].values.length; j++) {
            if (!filterModel.hasOwnProperty(filters[i].values[j].key)) {
              filterModel[filters[i].values[j].key] = {
                state: null,
                type: filters[i].type,
                name: filters[i].name,
                value: filters[i].values[j].value,
                key: filters[i].values[j].key,
                parameter: filters[i].parameter
              };
            }
          }
        }
      }
      return filterModel;
    }

    function setPropertiesOnFilterObject(filterConstant) {
      for (let i = 0; i < filterConstant.length; i++) {
        for (let j = 0; j < filterConstant[i].values.length; j++) {
          if (filterConstant[i].parameter) {
            filterConstant[i].values[j].parameter = filterConstant[i].parameter;
          }
          filterConstant[i].values[j].type = filterConstant[i].type;
          filterConstant[i].values[j].name = filterConstant[i].name;
        }
      }
      return filterConstant;
    }

    // function sortSingleFromMany(enums) {
    //   const sortedEnums = [];
    //   for (let i = 0; i < enums.length; i++) {
    //     if (enums[i].values.length > 1) {
    //       sortedEnums.push(enums[i]);
    //     } else {
    //       sortedEnums.unshift(enums[i]);
    //     }
    //   }
    //   return setMarkerForDivider(sortedEnums);
    // }

    // function setMarkerForDivider(sortedEnums) {
    //   for (let i = 0; i < sortedEnums.length; i++) {
    //     if (sortedEnums[i].values.length > 1) {
    //       if (i !== 0) {
    //         sortedEnums[i - 1].setBreaker = true;
    //       }
    //       break;
    //     }
    //   }
    //   return sortedEnums;
    // }

    // keys with 'https' is unique for the networks filter, so it can be used to target the network filter for upgrade
    // if condition is not fulfilled, then set networks filters
    // this evalutate the structure only
    function evaluateStorageIntegrity(view, filterModel) {
      const paramsCheckArray = ['state', 'key', 'parameter', 'state', 'type', 'value'];
      const storedFilters = storageObject.get(view);

      for (const key in storedFilters) {
        if (key.indexOf('https') >= 0) {
          for (let i = 0; i < paramsCheckArray.length; i++) {
            if (!storedFilters[key].hasOwnProperty(paramsCheckArray[i])) {
              setFiltersInStorage(view, filterModel);
            }
          }
          break;
        }
      }
    }

    // keys with 'https' is unique for the networks filter, so it can be used to target the network filter for upgrade
    // if condition is not fulfilled, then set networks filters
    // this evalutate data value (looking for changes in names of networks)
    function evaluateStoredFilterValues(view, filterModel) {
      const storedFilters = storageObject.get(view);

      for (const key in storedFilters) {
        if (filterModel[key]) {
          filterModel[key].state = storedFilters[key].state;
        }
      }

      for (const key in storedFilters) {
        if (key.indexOf('https') >= 0) {
          if (filterModel[key]) {
            if (storedFilters[key].value !== filterModel[key].value) {
              setFiltersInStorage(view, filterModel);
            }
          }
        }
      }
    }

    function setFiltersInStorage(view, filterModel) {
      storageObject.set(view, filterModel);
    }

    function getFiltersFromStorage(view) {
      return storageObject.get(view) || [];
    }

    function getFilterKeyValuePairArray(dataList, requestType, supportIcon) {
      const filtersList = [];
      for (let i = 0; i < dataList.length; i++) {
        const keyValuePair = {
          value: dataList[i].info.name,
          type: 'checkbox'
        };

        if (supportIcon && dataList[i].info.supportIcon) {
          keyValuePair.supportIcon = supportIcon;
        } else {
          keyValuePair.supportIcon = null;
        }

        keyValuePair.key = dataList[i].info._links.self.href;
        filtersList.push(keyValuePair);
      }
      return sortFilters(filtersList);
    }

    function addInputType(operatingSystems) {
      angular.forEach(operatingSystems, function (operatingSystem) {
        operatingSystem.type = 'checkbox';
      });
      return operatingSystems;
    }

    function sortFilters(filters) {
      filters.sort(function (filter1, filter2) {
        const a = filter1.value.toLowerCase();
        const b = filter2.value.toLowerCase();
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      });
      return filters;
    }

    return {
      createFilterModel: createFilterModel,
      updateFilterModel: updateFilterModel,
      // sortSingleFromMany: sortSingleFromMany,
      evaluateStorageIntegrity: evaluateStorageIntegrity,
      evaluateStoredFilterValues: evaluateStoredFilterValues,
      setFiltersInStorage: setFiltersInStorage,
      getFiltersFromStorage: getFiltersFromStorage,
      setPropertiesOnFilterObject: setPropertiesOnFilterObject,
      getFilterKeyValuePairArray: getFilterKeyValuePairArray,
      addInputType: addInputType
    };

  }

  filterDropdownService.$inject = ['localStorageService', '$cookies'];

  angular
    .module('printix-admin')
    .service('FilterDropdownService', filterDropdownService);

})();
